 
import { routerReducer, RouterReducerState } from "@ngrx/router-store";
import { ActionReducerMap, MetaReducer } from "@ngrx/store";

import { APP_FEATURE_KEY, AppState, initialState as app } from "./app/state";
import { PROGRAM_FEATURE_KEY, ProgramState, initialState as program } from "./program/state";
import { ANALYTICS_FEATURE_KEY, AnalyticsState, initialState as analytics } from "./analytics/state";

import { appReducer } from "./app/reducer";
import { programReducer } from "./program/reducer";
import { analyticsReducer } from "./analytics/reducer";

import { AppEffects } from "./app/effects";
import { ProgramEffects } from "./program/effects";
import { AnalyticsEffects } from "./analytics/effects";
import { logoutMetaReducer } from "./app/meta-reducers/logout.metareducer";
import { localStorageReduxSyncMetaReducer } from "./app/meta-reducers/local-storage.metareducer";

export interface RootState {
  [APP_FEATURE_KEY]: AppState;
  [PROGRAM_FEATURE_KEY]: ProgramState;
  [ANALYTICS_FEATURE_KEY]: AnalyticsState;
  router: RouterReducerState<any>;
}

export const initialRootState: RootState = {
  app,
  program,
  analytics,
  router: { navigationId: 0, state: {} },
};

export const reducers: ActionReducerMap<RootState> = {
  [APP_FEATURE_KEY]: appReducer,
  [PROGRAM_FEATURE_KEY]: programReducer,
  [ANALYTICS_FEATURE_KEY]: analyticsReducer,
  router: routerReducer,
};

export const effects = [AppEffects, ProgramEffects, AnalyticsEffects];

export const metaReducers: MetaReducer<any, any>[] = [localStorageReduxSyncMetaReducer, logoutMetaReducer];

export * as appActions from "./app/actions";
export * as programActions from "./program/actions";
export * as analyticsActions from "./analytics/actions";

export * as fromApp from "./app/selectors";
export * as fromProgram from "./program/selectors";
export * as fromAnalytics from "./analytics/selectors";
export * as fromRouter from "./router/selectors";
